import { useLocale } from '../i18n/LocaleContext';
import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const PrivacyPage = () => {
  const { t } = useLocale();
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <Section>
        <SectionTitle>{' '}{t('privacy.001')}{' '}</SectionTitle>
        <SectionContent>
          <p>{' '}{t('privacy.002')}{' '}</p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>{' '}{t('privacy.003')}{' '}</SectionTitle>
        <SectionContent>
          <p>{' '}{t('privacy.004')}{' '}</p>
          <ul>
            <li>
              <strong>{' '}{t('privacy.005')}{' '}</strong>{' '}{t('privacy.006')}{' '}</li>
            <li>
              <strong>{' '}{t('privacy.007')}{' '}</strong>{' '}{t('privacy.008')}{' '}</li>
            <li>
              <strong>{' '}{t('privacy.009')}{' '}</strong>{' '}{t('privacy.010')}{' '}</li>
            <li>
              <strong>{' '}{t('privacy.011')}{' '}</strong>{' '}{t('privacy.012')}{' '}</li>
          </ul>
          <p>{' '}{t('privacy.013')}{' '}</p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>{' '}{t('privacy.014')}{' '}</SectionTitle>
        <SectionContent>
          <p>{' '}{t('privacy.015')}{' '}</p>
          <ul>
            <li>{' '}{t('privacy.016')}{' '}</li>
            <li>{' '}{t('privacy.017')}{' '}</li>
            <li>{' '}{t('privacy.018')}{' '}</li>
            <li>{' '}{t('privacy.019')}{' '}</li>
            <li>{' '}{t('privacy.020')}{' '}</li>
            <li>{' '}{t('privacy.021')}{' '}</li>
          </ul>
          <p>{' '}{t('privacy.022')}{' '}</p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>{' '}{t('privacy.023')}{' '}</SectionTitle>
        <SectionContent>
          <p>{' '}{t('privacy.024')}{' '}</p>
          <p>{' '}{t('privacy.025')}{' '}</p>
          <p>{' '}{t('privacy.026')}{' '}</p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>{' '}{t('privacy.027')}{' '}</SectionTitle>
        <SectionContent>
          <p>{' '}{t('privacy.028')}{' '}</p>
          <p>{' '}{t('privacy.029')}{' '}</p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>{' '}{t('privacy.030')}{' '}</SectionTitle>
        <SectionContent>
          <p>{' '}{t('privacy.031')}{' '}</p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>{' '}{t('privacy.032')}{' '}</SectionTitle>
        <SectionContent>
          <p>{' '}{t('privacy.033')}{' '}</p>
          <ul>
            <li>{' '}{t('privacy.034')}{' '}</li>
            <li>{' '}{t('privacy.035')}{' '}</li>
            <li>{' '}{t('privacy.036')}{' '}</li>
            <li>{' '}{t('privacy.037')}{' '}</li>
            <li>{' '}{t('privacy.038')}{' '}</li>
          </ul>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>{' '}{t('privacy.039')}{' '}</SectionTitle>
        <SectionContent>
          <p>{' '}{t('privacy.040')}{' '}</p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>{' '}{t('privacy.041')}{' '}</SectionTitle>
        <SectionContent>
          <p>{' '}{t('privacy.042')}{' '}</p>
          <ul>
            <li>{' '}{t('privacy.043')}{' '}</li>
            <li>{' '}{t('privacy.044')}{' '}</li>
            <li>{' '}{t('privacy.045')}{' '}</li>
          </ul>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>{' '}{t('privacy.046')}{' '}</SectionTitle>
        <SectionContent>
          <p>{' '}{t('privacy.047')}{' '}</p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>{' '}{t('privacy.048')}{' '}</SectionTitle>
        <SectionContent>
          <p>{' '}{t('privacy.049')}{' '}<ContactEmail href="mailto:founders@noteician.com">founders@noteician.com</ContactEmail>
          </p>
        </SectionContent>
      </Section>

      <LastUpdated>{' '}{t('privacy.050')}{' '}</LastUpdated>
    </motion.div>
  );
};

const Section = styled.div`
  margin-bottom: 30px;
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 15px;
  color: var(--primary-dark);
`;

const SectionContent = styled.div`
  color: var(--dark-gray);
  line-height: 1.6;

  p {
    margin-bottom: 15px;
  }

  ul {
    margin-bottom: 15px;
    padding-inline-start: 20px;

    li {
      margin-bottom: 8px;
    }
  }
`;

const ContactEmail = styled.a`
  color: var(--primary);
  font-weight: 500;
  text-decoration: none;
  margin-inline-start: 5px;

  &:hover {
    text-decoration: underline;
  }
`;

const LastUpdated = styled.p`
  font-style: italic;
  color: var(--secondary);
  text-align: center;
  margin-top: 50px;
  font-size: 0.9rem;
`;

export default PrivacyPage;
